<span *ngIf="data">
    <i
        title="Copy `{{ data }}` to clipboard!"
        [ngClass]="{
            bi: true,
            'bi-clipboard-check': copied,
            'bi-clipboard': !copied
        }"
        (click)="copyToClipboard()"
    ></i>
</span>
